import { forkJoin, map } from 'rxjs';
import type { Observable } from 'rxjs';
import { get } from '@/shared/api/http';
import { authService } from '@/features/auth/services/auth.service';
import { mapUser, type BackendUserProfile, type BackendUASDevice } from '@/shared/api/user-mapper';

export function refreshUser(): Observable<void> {
  return forkJoin({
    profile: get<BackendUserProfile>('/api/v1/users/me/'),
    devices: get<BackendUASDevice[]>('/api/v1/devices/uas-devices/'),
  }).pipe(
    map(({ profile, devices }) => {
      authService.setUser(mapUser(profile, devices));
    }),
  );
}
